import { createSelector } from 'reselect';

/** @return {import('../../appConfigs/example.ts').AppConfigI} */
const getAppConfig = (state) => state.appConfig;

const getBaseURL = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.baseURL,
);

const getOpenIdConfig = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.openId,
);

const getUserProfilePath = createSelector(
	getOpenIdConfig,
	(openIdConfig) =>
		openIdConfig?.authority &&
		openIdConfig?.client_id &&
		`${openIdConfig?.authority}/user/?client_id=${openIdConfig?.client_id}`,
);

const getKeroSignupLink = createSelector(
	getOpenIdConfig,
	(openIdConfig) =>
		openIdConfig?.authority &&
		openIdConfig?.client_id &&
		`${openIdConfig.authority}/signup?client_id=${openIdConfig?.client_id}&amp;response_type=token%20id_token&amp;scope=openid%20profile%20grants`,
);

const getHosts = createSelector(getAppConfig, (appConfig) => appConfig?.hosts);

const getWwwHostname = createSelector(
	getHosts,
	(hosts) => `https://${hosts?.www}`,
);

const getCartHostname = createSelector(
	getHosts,
	(hosts) => `https://${hosts?.cart}`,
);

const getSalesforceHostname = createSelector(
	getHosts,
	(hosts) => `https://${hosts?.salesforce}`,
);

const getCustomerCommunityHostname = createSelector(
	getHosts,
	(hosts) => `https://${hosts?.customer_community}`,
);

const getGatorHostname = createSelector(getHosts, (hosts) => `${hosts?.gator}`);

const getAuthorizeUrl = createSelector(
	getHosts,
	(hosts) => `https://${hosts?.authorize_net}`,
);

const getManageHostname = createSelector(
	getHosts,
	(hosts) => `https://${hosts?.manage}`,
);

const getManagedAppsHostname = createSelector(
	getHosts,
	(hosts) => `https://${hosts?.managed_apps}`,
);

const sessionLength = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.session?.length,
);

const warningTime = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.session?.warningTime,
);

const getGaTrackerId = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.gaTrackerId,
);

const getGoogleTagManagerId = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.gtmContainerId,
);

const getSiteId = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.cartStack?.siteId,
);

const getTrackingScriptUrl = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.cartStack?.trackingScriptUrl,
);

const getGuestCredentials = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.guestAuth,
);

const getCartConfig = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.cart,
);

const getChatConfig = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.chatConfig,
);

const getAlgoliaConfig = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.algolia,
);

const getAlgoliaApplicationId = createSelector(
	getAlgoliaConfig,
	(algoliaConfig) => algoliaConfig?.applicationId,
);

const getAlgoliaSearchOnlyApiKey = createSelector(
	getAlgoliaConfig,
	(algoliaConfig) => algoliaConfig?.searchOnlyApiKey,
);

const getAcceptJsConfig = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.acceptJs,
);

const getGoogleMapsApiKey = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.googleMapsApiKey,
);

const getStripeConfig = createSelector(
	getAppConfig,
	(appConfig) => appConfig?.stripe,
);

const getStripePublishableKey = createSelector(
	getStripeConfig,
	(stripeConfig) => stripeConfig?.publishableKey,
);

const appConfigSelectors = {
	getAppConfig,
	getBaseURL,
	getHosts,
	getKeroSignupLink,
	getWwwHostname,
	getCartHostname,
	getSalesforceHostname,
	getCustomerCommunityHostname,
	getGatorHostname,
	getAuthorizeUrl,
	getManageHostname,
	getManagedAppsHostname,
	sessionLength,
	warningTime,
	getGaTrackerId,
	getGoogleTagManagerId,
	getSiteId,
	getTrackingScriptUrl,
	getGuestCredentials,
	getCartConfig,
	getChatConfig,
	getOpenIdConfig,
	getUserProfilePath,
	getAlgoliaConfig,
	getAlgoliaApplicationId,
	getAlgoliaSearchOnlyApiKey,
	getAcceptJsConfig,
	getGoogleMapsApiKey,
	getStripeConfig,
	getStripePublishableKey,
};

export default appConfigSelectors;
